import React from "react";
import { Grid, Typography, CardContent } from "@mui/material";
import { AdminTitleHolder } from "../../../common/sharedComponents/styles/card.style";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  StyledCard,
  VendorCardLabel,
  CustomButton,
} from "../../vendorRegistration/components/StepMain";
import moment from "moment";
import ProjectItemRequisitionModal from "./ProjectItemRequisitionModal";
import ProjectWorkflowModal from "./ProjectWorkflowModal";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  approveProjectWorkflow,
  rejectProjectWorkflow,
  getProjectDetails,
  getProjectItems,
} from "../redux/projectSlice";
import { useDispatch } from "react-redux";

function ProjectViewDetails() {
  const { projectDetails } = useSelector((state) => state.project);
  const { id } = useParams();
  const project = projectDetails?.project;
  const dispatch = useDispatch();
  const [openRequisitionModal, setOpenRequisitionModal] = React.useState(false);
  const [openWorkflowModal, setOpenWorkflowModal] = React.useState(false);
  const [openApprove, setOpenApprove] = React.useState(false);
  const [openReject, setOpenReject] = React.useState(false);
  const [editorState, setEditorState] = React.useState(
    EditorState.createEmpty(),
  );

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
  };

  const handleApprove = async () => {
    const payload = { projectId: id };
    const result = await dispatch(approveProjectWorkflow(payload));
    if (result.meta.requestStatus === "fulfilled") {
      setOpenApprove(false);
      dispatch(getProjectDetails(id));
    }
  };

  const handleReject = async () => {
    let reason = "";
    if (editorState.getCurrentContent().hasText()) {
      reason = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    }
    const payload = { projectId: id, reason };
    const result = await dispatch(rejectProjectWorkflow(payload));
    if (result.meta.requestStatus === "fulfilled") {
      setOpenReject(false);
      setEditorState(EditorState.createEmpty());
      dispatch(getProjectDetails(id));
    }
  };

  return (
    <>
      <AdminTitleHolder>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={6}>
            Project Details - {project?.project_name}
          </Grid>
          <Grid item xs={6} style={{ textAlign: "right" }}>
            {projectDetails?.workflowStatus?.is_approver && (
              <>
                <ApproveButton
                  onClick={() => setOpenApprove(true)}
                  variant="outlined"
                  size="large"
                  style={{ marginRight: "10px", height: "42px" }}
                >
                  Approve
                </ApproveButton>
                <RejectButton
                  onClick={() => setOpenReject(true)}
                  variant="outlined"
                  size="large"
                  style={{ marginRight: "10px", height: "42px" }}
                >
                  Reject
                </RejectButton>
              </>
            )}
            {projectDetails?.canSubmitToWorkflow && (
              <CustomButton
                onClick={() => setOpenWorkflowModal(true)}
                size="large"
                color="secondary"
                variant="outlined"
                className="invoiceErrbutn"
                style={{ marginRight: "10px" }}
              >
                Trigger Workflow
              </CustomButton>
            )}
            {!projectDetails?.workflowStatus?.is_approver && (
              <CustomButton
                onClick={() => setOpenRequisitionModal(true)}
                size="large"
                color="primary"
                variant="outlined"
                className="invoiceErrbutn"
              >
                Add Procurement Request
              </CustomButton>
            )}
          </Grid>
        </Grid>
      </AdminTitleHolder>
      <StyledCard>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={6} md={3}>
              <Typography className="label">PROJECT NAME</Typography>
              <VendorCardLabel>{project?.project_name || "-"}</VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">PROJECT CODE</Typography>
              <VendorCardLabel>{project?.project_code || "-"}</VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">PROJECT STATUS</Typography>
              <VendorCardLabel>
                {project?.project_status == "ON_HOLD"
                  ? "ON HOLD"
                  : project?.project_status == "IN_PROGRESS"
                  ? "IN PROGRESS"
                  : project?.project_status || "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">COMPANY</Typography>
              <VendorCardLabel>
                {project?.Company?.company_name || "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">BUSINESS UNIT</Typography>
              <VendorCardLabel>
                {project?.businessUnit?.businessUnitName || "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">PROJECT BUDGET</Typography>
              <VendorCardLabel>
                {project?.project_budget || "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">PLANNED START DATE</Typography>
              <VendorCardLabel>
                {project?.planned_company_start_date
                  ? moment(project.planned_company_start_date).format(
                      "DD-MM-YYYY",
                    )
                  : "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">PLANNED END DATE</Typography>
              <VendorCardLabel>
                {project?.planned_company_end_date
                  ? moment(project.planned_company_end_date).format(
                      "DD-MM-YYYY",
                    )
                  : "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">ACTUAL START DATE</Typography>
              <VendorCardLabel>
                {project?.actual_company_start_date
                  ? moment(project.actual_company_start_date).format(
                      "DD-MM-YYYY",
                    )
                  : "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">ACTUAL END DATE</Typography>
              <VendorCardLabel>
                {project?.actual_company_end_date
                  ? moment(project.actual_company_end_date).format("DD-MM-YYYY")
                  : "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography className="label">EXTENDED END DATE</Typography>
              <VendorCardLabel>
                {project?.extended_company_end_date
                  ? moment(project.extended_company_end_date).format(
                      "DD-MM-YYYY",
                    )
                  : "-"}
              </VendorCardLabel>
            </Grid>
            <Grid item xs={12} md={12}>
              <Typography className="label">STORE ADDRESS</Typography>
              <VendorCardLabel>{project?.storeAddress || "-"}</VendorCardLabel>
            </Grid>
            <Grid item xs={12} md={12}>
              <Typography className="label">STORE LOCATION</Typography>
              <VendorCardLabel>{project?.storeLocation || "-"}</VendorCardLabel>
            </Grid>
          </Grid>
        </CardContent>
      </StyledCard>
      <ProjectItemRequisitionModal
        open={openRequisitionModal}
        onClose={() => setOpenRequisitionModal(false)}
        onSuccess={() => {
          dispatch(getProjectItems(id));
        }}
      />
      <ProjectWorkflowModal
        open={openWorkflowModal}
        onClose={() => setOpenWorkflowModal(false)}
      />
      <Dialog open={openApprove} onClose={() => setOpenApprove(false)}>
        <DialogTitle>Please Confirm</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to approve this project?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenApprove(false)} color="inherit">
            Cancel
          </Button>
          <ApproveButton onClick={handleApprove} variant="contained">
            Approve
          </ApproveButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openReject}
        onClose={() => setOpenReject(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Please Confirm</DialogTitle>
        <DialogContent>
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={onEditorStateChange}
            placeholder="Add rejection reason..."
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenReject(false)} color="inherit">
            Cancel
          </Button>
          <RejectButton onClick={handleReject} variant="contained">
            Reject
          </RejectButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

const ApproveButton = styled(Button)`
  border-color: var(--button-color);
  color: var(--button-color);
  &:hover {
    border-color: var(--button-color);
    background-color: var(--button-color);
    color: white;
  }
  &.MuiButton-contained {
    background-color: var(--button-color);
    color: white;
  }
`;

const RejectButton = styled(Button)`
  border-color: #d32f2f;
  color: #d32f2f;
  &:hover {
    background-color: #d32f2f;
    color: white;
    border-color: #d32f2f;
  }
  &.MuiButton-contained {
    background-color: #d32f2f;
    color: white;
  }
`;

export default ProjectViewDetails;
